module.exports = __webpack_public_path__ + "img/mobile-banner1.e86a7252.png";